import styles from './commonTable.module.css';
import TableBody from './tableBody/TableBody';
import TableHeader from './tableHeader/TableHeader';

const CommonTable = ({ columns, data, setRowClickId }) => {
    return (
        <div className=''>
            {window.innerWidth > 768 ? (
                <table className={styles.table}>
                    <TableHeader columns={columns} />
                    <TableBody data={data} columns={columns} setRowClickId={setRowClickId} />
                </table>
            ) : (
                <div className={styles.mobileCards}>
                    {data.map((item, index) => (
                        <div key={index} className={styles.mobileCard} onClick={() => setRowClickId(item._id)}>
                            {columns.map((column, colIndex) => (
                                <div key={colIndex} className={styles.cardRow}>
                                    <span>{column.label}</span>

                                    <p>
                                        {column.render
                                            ? column.render(item[column.accessor], item)
                                            : (item[column.accessor] ?? 'N/A')}
                                    </p>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CommonTable;
